module.exports = __webpack_public_path__ + "f21eb0ddffc56b41f65c7e00495bdd02.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/P28 -  LavaBridge -SolariaGabriel copy.jpg
// module id = 149
// module chunks = 0